"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var getBasePlacement_1 = tslib_1.__importDefault(require("../utils/getBasePlacement"));

var enums_1 = require("../enums");
/**
 * @param placement
 * @param rects
 * @param offset
 */


function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement_1["default"](placement);
  var invertDistance = [enums_1.left, enums_1.top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {
    placement: placement
  })) : offset,
      _ref2 = _slicedToArray(_ref, 2),
      skidding = _ref2[0],
      distance = _ref2[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [enums_1.left, enums_1.right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

exports.distanceAndSkiddingToXY = distanceAndSkiddingToXY;
/**
 *
 */

function offset(_ref3) {
  var state = _ref3.state,
      options = _ref3.options,
      name = _ref3.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_1.placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
}

exports["default"] = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};